/**
 * Utilitaires pour la gestion des dates
 */

/**
 * Obtient la date du jour au format YYYY-MM-DD (format requis par les inputs de type date)
 * @returns La date du jour au format YYYY-MM-DD
 */
export const getTodayDate = (): string => {
  const today = new Date();
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, '0');
  const day = String(today.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

/**
 * Obtient la date dans N jours au format YYYY-MM-DD
 * @param days - Nombre de jours à ajouter (par défaut 7 pour une semaine)
 * @returns La date dans N jours au format YYYY-MM-DD
 */
export const getDateInDays = (days: number = 7): string => {
  const date = new Date();
  date.setDate(date.getDate() + days);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

/**
 * Obtient la date dans N mois au format YYYY-MM-DD
 * @param months - Nombre de mois à ajouter (par défaut 3)
 * @returns La date dans N mois au format YYYY-MM-DD
 */
export const getDateInMonths = (months: number = 3): string => {
  const date = new Date();
  date.setMonth(date.getMonth() + months);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

/**
 * Obtient la date il y a N mois au format YYYY-MM-DD
 * @param months - Nombre de mois à soustraire (par défaut 3)
 * @returns La date il y a N mois au format YYYY-MM-DD
 */
export const getDateMonthsAgo = (months: number = 3): string => {
  const date = new Date();
  date.setMonth(date.getMonth() - months);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

/**
 * Formate une date au format français DD/MM/YYYY
 * @param date - Date au format YYYY-MM-DD ou Date object
 * @returns Date formatée au format DD/MM/YYYY
 */
export const formatDateFR = (date: string | Date): string => {
  let dateObj: Date;
  if (typeof date === 'string') {
    dateObj = new Date(date);
  } else {
    dateObj = date;
  }
  
  if (isNaN(dateObj.getTime())) {
    return '';
  }
  
  const day = String(dateObj.getDate()).padStart(2, '0');
  const month = String(dateObj.getMonth() + 1).padStart(2, '0');
  const year = dateObj.getFullYear();
  return `${day}/${month}/${year}`;
};
